<template>
    <td>
        <div class="wrapper" ref="container">
            <slot></slot>
        </div>
        <TextButton
            v-show="isOverflow"
            :text="$t('show_more')"
            @click="$emit('click')"
        />
    </td>
</template>

<script lang="ts">
import Vue from 'vue';
import TextButton from '@/basic/TextButton.vue';
import { checkOverflow } from '@/common/js/utils';

export default Vue.extend({
    components:{
        TextButton
    },
    data() {

        return {
            isOverflow: false
        };

    },
    computed: {
        container(): HTMLDivElement {

            return this.$refs['container'] as HTMLDivElement;

        }
    },
    methods:{
        checkOverflow() {

            this.isOverflow = checkOverflow( this.container );

        }
    },
    mounted() {

        this.checkOverflow();

    },
});
</script>

<style lang="less" scoped>
.wrapper{
    margin-bottom: 8px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    text-overflow: ellipsis;
    line-clamp: 3;
    -webkit-box-orient: vertical;
}
</style>
